module.exports = "//static.hsappstatic.net/marketplace-storefront-base/static-1.11901/assets/images/G2_marketplace_banner.png"